import { render, staticRenderFns } from "./ColoredTextStatus.vue?vue&type=template&id=7c94a1d6&scoped=true"
import script from "./ColoredTextStatus.vue?vue&type=script&lang=js"
export * from "./ColoredTextStatus.vue?vue&type=script&lang=js"
import style0 from "./ColoredTextStatus.vue?vue&type=style&index=0&id=7c94a1d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c94a1d6",
  null
  
)

export default component.exports